/*
 * File: GetIssuedFormLink.ts
 * Author: Austin Robinson
 * Date Created: 9/21/2023
 * Copyright (c) DrivingDoc 2023
 */

import { privateApi } from 'api';

export type GetIssuedFormLinkParams = {
    id: string;
    action?: 'new_tab'
};

async function getIssuedFormLink(params: GetIssuedFormLinkParams) {
    if (!params.id) {
        return null
    }

    // make api call
    const result = await privateApi.get(`${import.meta.env.VITE_API_BASE_URL}/forms/issued/${params.id}/link`, {

    });

    if (params.action === 'new_tab') {
        window.open(result.data)
    }

    // return the blob
    return result.data as string;
}

// const useGetIssuedForm = createQuery<PDF[], GetIssuedForm, Error>({
//     queryKey: ['issued_form',
//     fetcher: (variables) => getIssuedForm(variables),
// enabled: (data) => !data,
// });

export { getIssuedFormLink };


